/** Bölüm yöneticisi — kabul sonrası uygulama / red nedenleri (HTML 3) */

export const MANAGER_REJECT_REASONS = [
  'MALİYET YÜKSEK',
  'SİSTEME UYGUN DEĞİL',
  'PROJE ÖMRÜ KISA',
  'KENDİ SORUMLULUK ALANINDA',
  'MEVCUT PROJE KAPSAMINDA',
  'DAHA ÖNCE VERİLMİŞ / MÜKERRER',
  'MEVZUATA AYKIRI',
  'KAYNAK / KAPASİTE YETERSİZ',
  'DİĞER',
]

export const MANAGER_DECISION = {
  ACCEPT: 'accept',
  REJECT: 'reject',
}

export const MANAGER_DECISION_LABELS = {
  [MANAGER_DECISION.ACCEPT]: 'Kabul',
  [MANAGER_DECISION.REJECT]: 'Red',
}

export const getManagerDecisionLabel = (result) =>
  MANAGER_DECISION_LABELS[result] || result || '—'
